import { render, staticRenderFns } from "./BookExercisePage.vue?vue&type=template&id=fd6e9a90&"
import script from "./BookExercisePage.vue?vue&type=script&lang=js&"
export * from "./BookExercisePage.vue?vue&type=script&lang=js&"
import style0 from "./BookExercisePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports